export default {
  v3SubmitErrBtnViewOrder: 'Ver Pedido',
  v3SubmitErrBtnBackHome: 'Início',
  v3SubmitErrBtnRetry: 'Tentar',
  v3SubmitErrBtnRelogin: 'Fazer login novamente',
  v3SubmitErrBtnSwitchPay: 'Alterar método de pagamento',
  v3SubmitErrBtnReorder: 'Refazer pedido',
  v3SubmitErrBtnSwitchServer: 'Mudar de servidor',
  v3SubmitErrBtnViewOrderStatus: 'Status do pedido',
  v3SubmitErrBtnBackStore: 'Voltar à loja',
  v3SubmitErrBtnGoUpdate: 'Atualizar',
  v3SubmitErrBtnResubscribe: 'Renovar assinatura',
  v3SubmitErrTipUpdateApp: 'Atualize pela loja de aplicativos',
  v3SubmitErrTipRelogin: 'Por favor, faça login novamente',

  v3SubmitErrMsg120009: 'Pedido processado – verifique sua mochila no jogo.',
  v3SubmitErrMsg120003: 'Erro nas informações do produto – selecione novamente.',
  v3SubmitErrMsg120016: 'Muitas solicitações – aguarde alguns segundos e tente novamente.',
  v3SubmitErrMsg120025: 'Parâmetros de solicitação anormais – faça login novamente e tente.',
  v3SubmitErrMsg121012: 'Canal de pagamento temporariamente indisponível – tente outro método.',
  v3SubmitErrMsg120012: 'Rede instável – verifique a conexão e tente novamente.',
  v3SubmitErrMsg120002: 'Nenhum personagem encontrado – crie um primeiro.',
  v3SubmitErrMsg121019: 'Erro nas informações do pedido – faça um novo pedido.',
  v3SubmitErrMsg120024: 'Presente de pré-registro já resgatado – não repita.',
  v3SubmitErrMsg120000: 'Login expirado – faça login novamente.',
  v3SubmitErrMsg120014: 'Número de pedido inválido – faça um novo pedido.',
  v3SubmitErrMsg121001: 'Recarga no jogo falhou – tente novamente mais tarde ou contate o suporte.',
  v3SubmitErrMsg120015: 'Valor de pagamento anormal – selecione o produto novamente.',
  v3SubmitErrMsg120001: 'Servidor não corresponde – mude para o servidor correto.',
  v3SubmitErrMsg120020: 'O canal de pagamento retornou erro – tente outro método.',
  v3SubmitErrMsg120010: 'Função de recarga temporariamente desativada – tente novamente mais tarde.',
  v3SubmitErrMsg120006: 'Falha na verificação do valor – selecione novamente.',
  v3SubmitErrMsg121010: 'Solicitação de recarga em sandbox inválida – use a versão oficial.',
  v3SubmitErrMsg120017: 'Número de pedido duplicado – verifique se já foi pago.',
  v3SubmitErrMsg120022: 'Falha na verificação do callback de pagamento – tente novamente mais tarde.',
  v3SubmitErrMsg121000: 'Sistema ocupado – tente novamente mais tarde.',
  v3SubmitErrMsg120011: 'ID do produto incorreto – selecione novamente.',
  v3SubmitErrMsg121015: 'Falha na verificação do valor de pagamento – faça um novo pedido.',
  v3SubmitErrMsg120004: 'Canal de pagamento não está aberto – escolha outro método.',
  v3SubmitErrMsg120005: 'Canal de pagamento em manutenção – use outro método.',
  v3SubmitErrMsg120007: 'ID de plataforma inválido – faça login novamente.',
  v3SubmitErrMsg120008: 'Parâmetros de solicitação insuficientes – reenvie.',
  v3SubmitErrMsg120013: 'Número de pedido do desenvolvedor inválido – faça um novo pedido.',
  v3SubmitErrMsg120018: 'Pagamento bloqueado pelo controle de risco – contate o suporte para verificação.',
  v3SubmitErrMsg120019: 'Falha na verificação do nome do pacote – use a versão oficial.',
  v3SubmitErrMsg120021: 'Falha na verificação do ID do produto – selecione novamente.',
  v3SubmitErrMsg120023: 'Erro ao entregar presente de pré-registro – verifique mais tarde.',
  v3SubmitErrMsg120026: 'Conta não encontrada – verifique o status da conta.',
  v3SubmitErrMsg120030: 'Estoque total insuficiente – escolha outro produto.',
  v3SubmitErrMsg120031: 'Você excedeu o limite de compra deste item – ajuste.',
  v3SubmitErrMsg120032: 'Versão do jogo muito antiga – baixe a versão mais recente.',
  v3SubmitErrMsg120080: 'Pagamento por agente limitado pelo controle de risco – use seu próprio método de pagamento.',
  v3SubmitErrMsg120081: 'Pagamento por agente atrasado pelo controle de risco – verifique o resultado mais tarde.',
  v3SubmitErrMsg121002: 'Cache do pedido inválido – faça um novo pedido.',
  v3SubmitErrMsg121003: 'Configuração de recarga não encontrada – contate o suporte.',
  v3SubmitErrMsg121004: 'Parâmetros estendidos insuficientes – reenvie.',
  v3SubmitErrMsg121005: 'Falha na gravação do cache – tente novamente mais tarde.',
  v3SubmitErrMsg121006: 'Falha na leitura do cache – tente novamente mais tarde.',
  v3SubmitErrMsg121007: 'Erro na configuração do tipo de recarga – contate o suporte.',
  v3SubmitErrMsg121011: 'Novos campos detectados pela Apple – atualize o aplicativo.',
  v3SubmitErrMsg121013: 'Pedido de renovação não encontrado – assine novamente.',
  v3SubmitErrMsg121014: 'Falha na descriptografia dos parâmetros de recarga – reenvie.',
  v3SubmitErrMsg121017: 'Este pedido foi reembolsado – contacte o suporte para confirmação.',
  v3SubmitErrMsg121018: 'Assinatura expirada – assine novamente.',
  v3SubmitErrMsg121020: 'Pedido cancelado – faça um novo pedido.',
  v3SubmitErrMsg121021: 'Erro na API do Google – tente novamente mais tarde.',
  v3SubmitErrMsg121022: 'Falha ao obter token de acesso – faça login novamente.',
  v3SubmitErrMsg121023: 'Status do pedido anormal – verifique o status do crédito.',
  v3SubmitErrMsg121024: 'Falha na confirmação do pedido – tente novamente mais tarde.'
};
